<main class="indices-wrap">
  <h2 class="sub-title sub-title-first">指數介紹</h2>
  <div class="detail-table-wrap">
    <div class="detail-table">
      <div class="item" *ngFor="let item of data">
        <div class="label">{{item.Name}}</div>
        <div class="desc">
          <!-- {{item.Val}} -->
           <div [innerHTML]="item.Val|html"></div>
        </div>
      </div>
    </div>
  </div>
  <h2 class="sub-title">指數行情</h2>
  <table class="etf-indices">
    <thead>
      <tr>
        <th>指數名稱</th>
        <th>日期</th>
        <th>收盤價</th>
        <th>日漲跌</th>
        <th>日漲跌幅(%)</th>
        <th>歷史行情</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngIf="navData">
        <th>{{navData.IndexName}}</th>
        <td>{{navData.Date}}</td>
        <td>{{navData.PriceStr}}</td>
        <td [ngClass]="{'pValue': navData.PriceChange > 0,'nValue': 0 > navData.PriceChange}">{{navData.PriceChangeStr}}</td>
        <td [ngClass]="{'pValue': navData.PriceChangeRatio > 0,'nValue': 0 > navData.PriceChangeRatio}">{{navData.PriceChangeRatioStr}}</td>
        <td> <a [routerLink]="'/etf/index-market/' + FundNo">
          <img class="download-icon" src="/assets/images/net-value.svg" alt="歷史淨值" />
        </a></td>
      </tr>
    </tbody>
  </table>

  <p-panel class="p-panel"
    [collapsed]="false "
    [toggleable]="false"
    *ngIf="navData">
    <ng-template pTemplate="header">
      {{navData.IndexName}}
    </ng-template>
    <ng-template pTemplate="headericons">
      <img class="black-arrow" src="/assets/images/black-arrow.svg" />
    </ng-template>
    <!-- <div class="panel-item">
      <div class="name">指數名稱</div>
      <div class="desc">
        {{navData.IndexName}}
      </div>
    </div> -->
    <div class="panel-item">
      <div class="name">日期</div>
      <div class="desc">
        {{navData.Date}}
      </div>
    </div>

    <div class="panel-item">
      <div class="name">收盤價</div>
      <div class="desc">
        {{navData.PriceStr}}
      </div>
    </div>

    <div class="panel-item">
      <div class="name">日漲跌</div>
      <div class="desc" [ngClass]="{'pValue': navData.PriceChange > 0,'nValue': 0 > navData.PriceChange}">
        {{navData.PriceChangeStr}}
      </div>
    </div>

    <div class="panel-item">
      <div class="name">日漲跌幅(%)</div>
      <div class="desc" [ngClass]="{'pValue': navData.PriceChangeRatio > 0,'nValue': 0 > navData.PriceChangeRatio}">
        {{navData.PriceChangeRatioStr}}
      </div>
    </div>

    <div class="panel-item">
      <div class="name">歷史行情</div>
      <div class="desc">
        <a [routerLink]="'/etf/index-market/' + FundNo">
          <img class="download-icon" src="/assets/images/net-value.svg" alt="歷史淨值" />
        </a>
      </div>
    </div>
  </p-panel>
</main>

<main class="indices-wrap" *ngIf="getIndexNoFinalTrialRes?.IndexNoFinalTrial?.length">
  <h2 class="sub-title">指數成分股審核/調整公告</h2>
  <div class="rrv-table-container">
    <table class="rrv-table">
      <thead>
        <tr>
          <th>成分股審核/調整生效日期</th>
          <th>審核/調整前<br/>成分股檔數</th>
          <th>此次新增<br/>成分股檔數</th>
          <th>此次刪除<br/>成分股檔數</th>
          <th>審核/調整後<br/>成分股檔數</th>
        </tr>
      </thead>
      <ng-container *ngFor="let item of getIndexNoFinalTrialRes.IndexNoFinalTrial | slice:0:displayCount">
        <tbody>
          <tr>
            <td>{{item.CBirthDateStr}}</td>
            <td>{{item.CDivBirth}}</td>
            <td>{{item.CAddBirth}}</td>
            <td>{{item.CDelBirth}}</td>
            <td>{{item.CLastBirth}}</td>
          </tr>
        </tbody>
      </ng-container>
    </table>
  </div>
  <ng-container *ngFor="let item of getIndexNoFinalTrialRes.IndexNoFinalTrial | slice:0:displayCount">
    <p-panel class="p-panel p-panel-index" [collapsed]="false" [toggleable]="true">
      <ng-template pTemplate="header">
        <div>
          <a class="name">
            <div>{{getIndexNoFinalTrialRes.CStockName}}</div>
          </a>
        </div>
      </ng-template>
      <ng-template pTemplate="headericons">
        <img class="black-arrow" src="/assets/images/black-arrow.svg" />
      </ng-template>
        <div class="panel-item">
          <div class="name">成分股審核/調整生效日期</div>
          <div class="desc">
            {{item.CBirthDateStr}}
          </div>
        </div>
        <div class="panel-item">
          <div class="name">審核/調整前<br/>成分股檔數</div>
          <div class="desc">
            {{item.CDivBirth}}
          </div>
        </div>
        <div class="panel-item">
          <div class="name">此次新增<br/>成分股檔數</div>
          <div class="desc">
            {{item.CAddBirth}}
          </div>
        </div>
        <div class="panel-item">
          <div class="name">此次刪除<br/>成分股檔數</div>
          <div class="desc">
            {{item.CDelBirth}}
          </div>
        </div>
        <div class="panel-item">
          <div class="name">審核/調整後<br/>成分股檔數</div>
          <div class="desc">
            {{item.CLastBirth}}
          </div>
        </div>
      </p-panel>
  </ng-container>
  <button *ngIf="(getIndexNoFinalTrialRes.IndexNoFinalTrial?.length || 0) > displayCount" class="arrow-btn" (click)="showMore()">
    顯示更多
    <div class="top-arrow"></div>
  </button>
  <p class="no-data" *ngIf="(getIndexNoFinalTrialRes.IndexNoFinalTrial?.length || 0) <= displayCount && getIndexNoFinalTrialRes.IndexNoFinalTrial?.length">無更多資料</p>
  <div style="margin-top: 10px;" class="no-data" *ngIf="!getIndexNoFinalTrialRes?.IndexNoFinalTrial?.length">無相關資料</div>
  <div class="rrv-remark">
    上表指數成分股檔數異動資訊包含「定期審核換股資訊」與「非定期審核換股資訊」，上表資訊係由本公司自行計算，僅供參考，投資人仍須以指數編製公司之公告為準。
    基金績效可能受定審換股成本以外之因素影響，請投資人注意申購基金前應詳細閱讀基金公開說明書，充分評估基金投資特性與風險，
    更多基金評估之相關資料(如基金各項費用比率等)可至投信投顧公會網站之「境內基金各項資料」查詢。
  </div>
</main>
